'use es6';

export default {
  SMALL: 16,
  LARGE: 64
};
export var ITEMS_PER_ROW = 4;